const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloaderr16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 1a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 1-0.07031v-0.34375l1.5859-1.5859-1.5859-1.5859v-2.4141h2.4141l1.5859 1.5859 1.5859-1.5859h0.34375a7 7 0 0 0 0.07031-1 7 7 0 0 0-7-7z",
    fill: "#3771c8",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103 4v4h-2l3 3 1-1v-1h1l1-1h-2v-4z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 12v1h5.5859l-1-1z",
    fill: "#fff",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 10v1l2 2-2 2v1h1l2-2 2 2h1v-1l-2-2 2-2v-1h-1l-2 2-2-2z",
    color: "#000000",
    fill: "#d40000",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloaderr16);
export default __webpack_public_path__ + "static/media/download.err.16.a13c28eb0254d86eca7a49752dacbebf.svg";
export { ForwardRef as ReactComponent };